'use strict';

import { Entity } from '../Entity';

export class UserSignaturePic extends Entity {
  protected signaturePicId;
  protected signaturePicName;

  protected user;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.signaturePicId = data.signaturePicId;
    this.signaturePicName = data.signaturePicName;
  }

  public getSignaturePicId() {
    return this.signaturePicId;
  }

  public getSignaturePicName() {
    return this.signaturePicName;
  }
}
